import { forwardRef, JSX } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';
import { AssetId } from '~modules/media-library/model/Asset';
import { Button } from '~modules/media-library/view/Button';
import { CanvaIntro } from '~modules/media-library/view/CanvaModal/CanvaIntro';

type CanvaModalPanelProps = {
  onClose?: () => void;
  assetId: AssetId;
};

export const CanvaModalPanel = forwardRef<HTMLDivElement, JSX.IntrinsicElements['div'] & CanvaModalPanelProps>(
  function CanvaModalPanel({ onClose, className, assetId, ...TheirProps }, ref) {
    return (
      <div
        className={`ml--detail-modal--panel bg-white overflow-y-auto rounded-md shadow-xl w-full max-w-lg max-h-lg min-h-0 max-h-full flex flex-col relative ${
          className ? className : ''
        }`}
        {...TheirProps}
        ref={ref}
      >
        <Button variant="icon" className="absolute top-0 right-0 border-none" onClick={onClose}>
          <CloseIcon />
        </Button>
        <CanvaIntro assetId={assetId} onClose={onClose} />
      </div>
    );
  },
);
